import * as tslib_1 from "tslib";
import { MatPaginatorIntl } from '@angular/material';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
// Custom packages
// const italianRangeLabel = (page: number, pageSize: number, length: number) => {
//   if (length === 0 || pageSize === 0) { return `0 di ${length}`; }
//   length = Math.max(length, 0);
//   const startIndex = page * pageSize;
//   // If the start index exceeds the list length, do not try and fix the end index to the end.
//   const endIndex = startIndex < length ?
//     Math.min(startIndex + pageSize, length) :
//     startIndex + pageSize;
//   return `${startIndex + 1} - ${endIndex} di ${length}`;
// };
// export function getItalianPaginatorIntl() {
//   const paginatorIntl = new MatPaginatorIntl();
//   paginatorIntl.itemsPerPageLabel = 'Risultati per pagina:';
//   paginatorIntl.nextPageLabel = 'Pagina successiva';
//   paginatorIntl.previousPageLabel = 'Pagina precedente';
//   paginatorIntl.getRangeLabel = italianRangeLabel;
//   return paginatorIntl;
// }
var PaginatorIntlService = /** @class */ (function (_super) {
    tslib_1.__extends(PaginatorIntlService, _super);
    function PaginatorIntlService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemsPerPageLabel = 'Risultati per pagina:';
        _this.nextPageLabel = 'Pagina successiva';
        _this.previousPageLabel = 'Pagina precedente';
        _this.getRangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return "0 di " + length;
            }
            length = Math.max(length, 0);
            var startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            var endIndex = startIndex < length ?
                Math.min(startIndex + pageSize, length) :
                startIndex + pageSize;
            return startIndex + 1 + " - " + endIndex + " di " + length;
        };
        return _this;
    }
    /**
     * Inject with translateService this class and
     * force re-translation of some data like labels
     *
     * @see https://stackoverflow.com/questions/46869616/how-to-use-matpaginatorintl
     *
     * @since 1.0.0
     */
    PaginatorIntlService.prototype.injectTranslateService = function (translate) {
        var _this = this;
        this.translate = translate;
        this.translate.onLangChange.subscribe(function () {
            _this.translateLabels();
        });
        this.translateLabels();
    };
    /**
     * Translate paginator's string and push new translator
     * into the injected object
     *
     * @since 1.0.0
     */
    PaginatorIntlService.prototype.translateLabels = function () {
        var _this = this;
        forkJoin(this.translate.get('common.paginator.itemsPerPage'), this.translate.get('common.paginator.nextPage'), this.translate.get('common.paginator.prevPage'))
            .pipe(take(1))
            .subscribe(function (res) {
            _this.itemsPerPageLabel = res[0];
            _this.nextPageLabel = res[1];
            _this.previousPageLabel = res[2];
        });
    };
    return PaginatorIntlService;
}(MatPaginatorIntl));
export { PaginatorIntlService };
